import { useMemo } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'

import {
  Popover,
  PopoverItem,
  PopoverItemNaked,
} from '../shared-components/BUI/Popover'

import { useNavigation } from '@/context/navigationContext'
import { useUser } from '@/context/userContext'

const BuilderInfo = styled(PopoverItemNaked)`
  ${({ theme }) => theme.font.body03};
  font-weight: 600;
  color: ${({ theme }) => theme.colour.secondary._700};
  border-bottom: 1px solid ${({ theme }) => theme.colour.neutral.border};
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
`

const LogoWrapper = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 1px solid ${({ theme }) => theme.colour.neutral.border};
  background-color: ${({ theme }) => theme.colour.neutral.surface};
`

type Props = {
  children?: React.ReactNode
}

export const CorePageSideNavSettings: React.FC<Props> = ({ children }) => {
  const { builder } = useUser()
  const { settingsConfig } = useNavigation()

  const logo = builder?.logoUrl
  const name = builder?.company?.name

  const settingsMenu = useMemo(() => {
    return (
      <>
        <BuilderInfo>
          {logo && (
            <LogoWrapper>
              <Image
                src={logo}
                width={24}
                height={24}
                alt="builder logo"
                style={{ objectFit: 'contain' }}
              />
            </LogoWrapper>
          )}
          {name}
        </BuilderInfo>

        {settingsConfig?.map((item) => (
          <Link href={item.path} passHref key={item.id}>
            <PopoverItem>
              {item.icon && <item.icon size={18} />}
              {item.title}
            </PopoverItem>
          </Link>
        ))}
      </>
    )
  }, [logo, name, settingsConfig])

  return (
    <Popover
      arrowPointAtCenter
      placement="topRight"
      showArrow={false}
      content={settingsMenu}
      getPopupContainer={() => document.getElementById('bp-side-nav')}
    >
      {children}
    </Popover>
  )
}
